<div style="position: absolute; height: 4px; width: 100%; z-index: 1">
  @if (loading()) {
    <mat-progress-bar mode="indeterminate"/>
  }
</div>
